import { Component } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { CoreService } from './service/core.service';
import { TranslateService } from '@ngx-translate/core';
import { HrIntegrationService } from './service/hr-integration.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  isModuleLoading=false;

  constructor(private coreService: CoreService,  private router: Router,private translate: TranslateService, private hrIntegrationService: HrIntegrationService) {
    // window.onload = function () {
      if(this.getCookie("bquick") != 'loggedin'){
        console.log('cleared token');
        localStorage.removeItem("cmptoken");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("lcstg");
        localStorage.removeItem("urpg");
      }
    // }
    // window.onbeforeunload = function(e) {
    //   // console.log('Dialog text here.');
    //   localStorage.removeItem("cmptoken");
    //   localStorage.removeItem("auth_token");
    //   localStorage.removeItem("lcstg");
    //   localStorage.removeItem("urpg");
    // };

      this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        // Lazy module is starting to load
        this.isModuleLoading = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        // Lazy module has finished loading
        this.isModuleLoading = false;
      }
    });
  }
  ngOnInit(): void {
    if (localStorage.getItem('auth_token')) {
      this.hrIntegrationService.init();
    }
    this.translate.use('English').subscribe((data) => {
      var label = this.coreService.getUserData('cmp_tax_label');
      console.log('label', label);
      if(label){
        const data1 = this.replaceVat(data,label);
        this.translate.setTranslation(
          this.translate.currentLang,
          data1,
          true
        );
      }

        
    });
  }

    replaceVat(obj: any, label: string='VAT'): any {
    if (typeof obj === 'string') {
      return obj.replace(/\bvat\b/gi, label);
     }
    if (typeof obj === 'string') {
     
      obj = obj.split('VAT').join(label);
      obj = obj.split('Vat').join(label);
      return obj.split('vat').join(label);
    }

    if (Array.isArray(obj)) {
      return obj.map(item => this.replaceVat(item, label));
    }

    if (obj !== null && typeof obj === 'object') {
      Object.keys(obj).forEach(key => {
        obj[key] = this.replaceVat(obj[key], label);
      });
    }

    return obj;
  }

  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
        c = ca[i].replace(/^\s+/g, '');
        if (c.indexOf(cookieName) == 0) {
            return c.substring(cookieName.length, c.length);
        }
    }
    return '';
}

}